"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/_dom-helpers@3.3.1@dom-helpers/transition/isTransform.js
// module id = 24
// module chunks = 0